import { createContext } from 'react';
import * as React from 'react';

let apiaApiId: string | undefined;

export function getApiaApiId() {
  if (!apiaApiId) throw new Error('There is no apia api id');
  return apiaApiId;
}

const ApiaApiId = createContext<string | undefined>('apiaApi');

const ApiaApiContext = ({
  children,
  id,
}: {
  id: string;
  children: React.ReactNode;
}) => {
  apiaApiId = id;
  return <ApiaApiId.Provider value={id}>{children}</ApiaApiId.Provider>;
};

export default React.memo(ApiaApiContext);
